if (!customElements.get('main-favorites')) {
    /**
     * Represents the MainFavorites custom element.
     * @class
     * @extends HTMLElement
     */
    class MainFavorites extends HTMLElement {
        constructor() {
            super();
            this.productGrid = this.querySelector('ul.favorites-grid');
            this.spinner = this.querySelector('.loading-spinner');
            this.emptyStateEl = document.getElementById('empty');

            if (this.favorites.length > 0) {
                this.fetchProducts();
            } else {
                this.emptyStateEl.classList.remove('hidden');
                this.spinner.classList.add('hidden');
            }
        }

        get favorites() {
            const valueCookie = getCookie('favorites');
            let favorites = [];
            if (valueCookie) {
                const cookieParsed = JSON.parse(valueCookie);
                if (Array.isArray(cookieParsed)) {
                    favorites = cookieParsed;
                }
            }
            return favorites;
        }

        /**
         * Fetches the HTML content of a product using its handle.
         *
         * @param {string} handle - The handle of the product.
         * @returns {Promise<HTMLLIElement>} - A promise that resolves to an HTML list item element containing the fetched product HTML.
         */
        async fetchProductHTML(handle) {
            const productHTML = await fetch(`/products/${handle}?section_id=main-favorites`).then((res) => res.text());

            const parser = new DOMParser();
            const doc = parser.parseFromString(productHTML, 'text/html');
            const favoritesResult = doc.querySelector('.favorites-results product-card');
            if (favoritesResult) {
                favoritesResult.querySelectorAll('img[data-src]').forEach((img) => setImageSources(img));
                const li = document.createElement('li');
                li.appendChild(favoritesResult);
                return li;
            }

            return null;
        }

        /**
         * Fetches products and appends them to the product grid.
         * @returns {Promise<Array<HTMLElement>>} An array of HTML elements representing the fetched products.
         */
        async fetchProducts() {
            const batchedFavorites = batchArray(this.favorites, 4);
            await Promise.all(
                batchedFavorites.map(async (favoritesArray) => {
                    const productsHTML = await Promise.all(favoritesArray.map(async (handle) => this.fetchProductHTML(handle)));
                    productsHTML.forEach((el) => {
                        try {
                            return this.productGrid.appendChild(el);
                        } catch (error) {}
                    });
                    return productsHTML;
                })
            );
            this.spinner.classList.add('hidden');
        }
    }

    customElements.define('main-favorites', MainFavorites);
}
